export const ACCESS_TOKEN = 'accessToken';
export const AVAILABILITY_SETTINGS = 'availabilitySettings';
export const PWA_INSTALL_POPUP_IOS = 'pwaInstallPopupIOS';
